import EventEmitter from '../../helpers/EventEmmiter';
import {prepareOptions} from '../../helpers/common';

require('./e3-select.scss');

class E3Select extends EventEmitter {
    _container = null;
    _wrapper = null;
    _list = null;
    _title = null;
    _items = [];
    _default = {
        wrapperClass: 'e3-select'
    };
    _options = {
        className: [],
        position: 'top',
        initValue: null,
        hidden: false,
        placeholder: 'Select'
    };

    constructor(container, options = {}, items = []) {
        super();

        this._options = prepareOptions(this._options, options);
        this._container = container;
        this._items = items;

        this._init();
    }

    static convertToSelectArray(array, name, value) {
        return array.map((item) => ({name: item[name], value: item[value]}))
    }

    _init() {
        this._createElement();
        this._bindActions();
    }

    _createElement() {
        const {className, position, initValue, hidden, placeholder} = this._options;
        const {wrapperClass} = this._default;
        const wrapper = document.createElement('div');
        const title = document.createElement('span');
        const list = document.createElement('ul');

        // related to explorer limitation of element.classList.add(...[])
        wrapper.classList.add(wrapperClass);

        className.forEach((_className) => wrapper.classList.add(_className));

        title.classList.add(`${wrapperClass}__title`);
        list.classList.add(`${wrapperClass}__list`);
        list.classList.add(`${wrapperClass}__list--${position}`);

        this._items.forEach((item) => {
            const li = document.createElement('li');

            li.classList.add(`${wrapperClass}__list-element`);
            li.dataset.value = item.value;
            li.innerText = item.name;

            list.appendChild(li);
        });

        wrapper.appendChild(list);
        wrapper.appendChild(title);

        this._wrapper = wrapper;
        this._list = list;
        this._title = title;

        this._setValue(initValue);

        if (hidden) this.hide();

        this._container.appendChild(wrapper);
    }

    _showAll() {
        if(!this._list.children) return ;

        let item = null;

        for(item of this._list.children){
            item.classList.remove('hidden');
        }
    }

    _setValue(value) {
        this._showAll();
        const {placeholder} = this._options;
        const index = this._items.findIndex((item) => typeof item.value === "number"
            ? item.value === Number(value)
            : item.value === value);
        const current = this._items[index];
        const name = current ? current.name : placeholder;
        value = current ? current.value : null;

        this._fireEvent('set.value', {value});

        this._title.innerText = name;
        this._title.dataset.value = value;
        this._list.children[index].classList.add('hidden');
    }

    _bindActions() {
        this._onTitleClickBound = this._onTitleClick.bind(this);
        this._onSelectListItemBound = this._onSelectListItem.bind(this);

        this._title.addEventListener('click', this._onTitleClickBound, false);
        this._list.addEventListener('click', this._onSelectListItemBound, false);
    }

    _unbindActions() {
        this._title.removeEventListener('click', this._onTitleClickBound, false);
        this._list.removeEventListener('click', this._onSelectListItemBound, false);

        document.removeEventListener('click', this._closeListBound, false);

        this._onTitleClickBound = null;
        this._onSelectListItemBound = null;
        this._closeListBound = null;
    }

    _onTitleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        return this._isListOpen()
            ? this._closeList()
            : this._openList()
    }

    _onSelectListItem(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const target = e.target;
        const value = target.dataset.value;

        this._setValue(value);
        this._closeList();
    }

    _isListOpen() {
        const {wrapperClass} = this._default;

        return this._list.classList.contains(`${wrapperClass}__list--open`);
    }

    _openList() {
        const {wrapperClass} = this._default;

        this._closeListBound = this._closeList.bind(this);

        setTimeout(() => document.addEventListener('click', this._closeListBound, false), 0);

        return this._list.classList.add(`${wrapperClass}__list--open`);
    }

    _closeList() {
        const {wrapperClass} = this._default;

        document.removeEventListener('click', this._closeListBound, false);
        this._closeListBound = null;

        return this._list.classList.remove(`${wrapperClass}__list--open`);
    }

    set(value) {
        this._setValue(value);
    }

    get() {
        return this._title.dataset.value;
    }

    hide() {
        const {wrapperClass} = this._default;

        this._wrapper.classList.add(`${wrapperClass}--hidden`);
    }

    show() {
        const {wrapperClass} = this._default;

        this._wrapper.classList.remove(`${wrapperClass}--hidden`);
    }

    destroy() {
        this._unbindActions();
        this._container.removeChild(this._wrapper);

    }
}

export default E3Select;
